import { VISIT_DOCUMENTS_TYPES } from './constants';
import { makeRequiredFieldsValidator } from '../../../../../hocs/useFormWithValidation';

export const initialStateFields = {
  [VISIT_DOCUMENTS_TYPES.CATEGORY]: null,
  [VISIT_DOCUMENTS_TYPES.SUB_CATEGORY]: null,
  [VISIT_DOCUMENTS_TYPES.DOCUMENTS]: null,
};

export const validateRequiredFields = makeRequiredFieldsValidator([
  VISIT_DOCUMENTS_TYPES.CATEGORY,
  VISIT_DOCUMENTS_TYPES.SUB_CATEGORY,
  VISIT_DOCUMENTS_TYPES.DOCUMENTS,
]);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/AddDocumentForm/fields.js